import { useState, useEffect, useLayoutEffect } from 'react';
import Cookies from 'js-cookie';
import { LeftNav } from '../components/nav';
import { AgentPrompt } from '../components/agent';

export default function AgentPage() {
  const [ready, setReady] = useState();
  const [initial, setInitial] = useState('');

  useLayoutEffect(() => {
    const lp = Cookies.get('latestPrompt');
    if (lp) {
      setInitial(lp);
    }
    Cookies.set('latestPrompt', '');
    setReady(true);
  }, []);

  return <LeftNav>{ready && <AgentPrompt prompt={initial} autoRun />}</LeftNav>;
}
